import {CONTACT} from "../../constants/contact";
export function fetchContact(params) {
    return{
        type: CONTACT.FETCH_CONTACT.MAIN,
        params
    }
}